"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSimpleMaterializer = void 0;
const tslib_1 = require("tslib");
const utils_1 = require("./utils");
const lodash_1 = tslib_1.__importDefault(require("lodash"));
const createSimpleMaterializer = ({ transform } = {}) => {
    const templates = {};
    const cache = {};
    const resolveRef = (val) => {
        let resolved;
        if (val.refPath.length === 3) {
            resolved = get(val.refPath);
        }
        else {
            const [key1, key2, key3, ...rest] = val.refPath;
            const node = get([key1, key2, key3]);
            resolved = rest.length && typeof node !== 'undefined' ? (0, utils_1.getByArray)(node, rest) : node;
        }
        if (typeof resolved === 'undefined') {
            return val.defaultValue;
        }
        return resolved;
    };
    const get = (path) => {
        if (lodash_1.default.has(cache, path)) {
            return (0, utils_1.getByArray)(cache, path);
        }
        const maybeTemplate = (0, utils_1.getByArray)(templates, path);
        if (typeof maybeTemplate === 'undefined') {
            return undefined;
        }
        const { template, schema } = maybeTemplate;
        const nodeSchema = schema;
        if (nodeSchema === utils_1.EMPTY_SCHEMA || isPrimitive(template)) {
            const transformedValue = transform ? transform(template, path) : template;
            (0, utils_1.setByArray)(cache, path, transformedValue);
            return transformedValue;
        }
        let newVal = {};
        (0, utils_1.traverse)(template, (objValue, objPath) => {
            if ((0, utils_1.isRef)(objValue)) {
                const resolved = resolveRef(objValue);
                if (objPath.length > 0) {
                    (0, utils_1.setByArray)(newVal, objPath, resolved);
                }
                else {
                    newVal = resolved;
                }
                return true; // exit traverse
            }
            if (Array.isArray(objValue)) {
                (0, utils_1.setByArray)(newVal, objPath, []);
                return;
            }
            if (objPath.length > 0) {
                (0, utils_1.setByArray)(newVal, objPath, objValue);
            }
        }, utils_1.SMALL_FACTOR);
        const transformedValue = transform ? transform(newVal, path) : newVal;
        (0, utils_1.setByArray)(cache, path, transformedValue);
        return transformedValue;
    };
    return {
        cleanAll() { },
        update() {
            throw new Error('Simple materializer does not support updates');
        },
        batch(batchFunction, _runAndReport = (fn) => fn()) {
            const allInvalidations = [];
            batchFunction((key1, key2, key3, template, schema) => {
                (0, utils_1.set3d)(templates, key1, key2, key3, { template, schema });
                allInvalidations.push([key1, key2, key3]);
            });
            return allInvalidations;
        },
        get,
    };
};
exports.createSimpleMaterializer = createSimpleMaterializer;
const isPrimitive = (value) => {
    switch (typeof value) {
        case 'object':
            return value === null;
        case 'function':
            return false;
        default:
            return true;
    }
};
//# sourceMappingURL=simpleMaterializer.js.map